
























































































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import { Case } from '@/modules/Case/interfaces/case'
import AppQueries from '@/mixins/queries'
import VehicleDialog from '@/modules/Vehicle/scripts/vehicle-dialog'
import InsuredDialog from '@/modules/Insured/scripts/insured-dialog'
import PropertyDialog from '@/modules/Property/scripts/property-dialog'
import { translateInsuredRelatioKey } from '@/utils/translate'
import { showOwnershipLabel } from '@/modules/Vehicle/helpers/vehicle-ownership-options'
import { showUseageLabel } from '@/modules/Vehicle/helpers/vehicle-useage-options'

@Component({
  components: {
    FoldingCard,
    AppDialog
  }
})
export default class CaseDetailRelated extends mixins(AppQueries, VehicleDialog, InsuredDialog, PropertyDialog) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case
  showOwnershipLabel = showOwnershipLabel
  showUseageLabel = showUseageLabel
  caseId: number | null = null

  get vehicles () {
    if (!this.caseInfo) {
      return []
    }

    return this.caseInfo.vehicles
  }

  tableColumn = [
    { field: 'name',
      title: 'Vehicle',
      slots: { default: 'vehicle_name_default' }
    },
    { field: 'vin',
      title: 'VIN',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.vin || '-')
        ]
      }
      }
    },
    { field: 'ownership',
      title: 'Ownership',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', showOwnershipLabel(row.ownership))
        ]
      }
      }
    },
    { field: 'useage',
      title: 'Useage',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', showUseageLabel(row.useage))
        ]
      }
      },
      resizable: true
    },
    { field: 'year',
      title: 'Year',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.year || '-')
        ]
      }
      }
    },
    { field: 'model',
      title: 'Model',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.model || '-')
        ]
      }
      }
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  propertyTableColumn = [
    { field: 'address',
      title: 'Address',
      slots: { default: 'address_default' },
      resizable: true
    },
    { field: 'city',
      title: 'City',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.city || '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'state',
      title: 'State',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.state || '-')
        ]
      }
      }
    }
  ]

  insuredTableColumn = [
    { field: 'name',
      title: 'Insured Name',
      slots: { default: 'insured_name_default' },
      resizable: true
    },
    { field: 'relationShip',
      title: 'Relationship',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.relationShip ? translateInsuredRelatioKey(row.relationShip) : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'dateOfBirth',
      title: 'Date Of Birth',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.dateOfBirth || '-')
        ]
      }
      }
    }
  ]

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  routeToDetail (item: any, routeName: string) {
    this.$router.push({
      name: routeName,
      params: { id: item.id + '' }
    })
  }

  routeToRelationship (e: Event, item: any) {
    e.preventDefault()
    e.stopPropagation()
    this.routeTo('AccountContactRelationDetail', {
      id: item.relation.id
    })
  }

  newVehicle (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showVehicleEditDialog(e)
  }

  clearForm () {
    this.caseId = null
    this.hideVehicleEditDialog()
    this.hideInsuredEditDialog()
    this.hidePropEditDialog()
  }

  get insureds () {
    if (!this.caseInfo) {
      return []
    }

    return this.caseInfo.insureds
  }

  get properties () {
    if (!this.caseInfo) {
      return []
    }

    return this.caseInfo.properties
  }

  @Emit('success')
  onFormSuccess () {
    // do nothing
  }

  routeToList (routeName: string) {
    this.$router.push({
      name: routeName,
      params: {
        caseId: this.caseInfo.id + ''
      }
    })
  }

  async editVehicle (e: Event, vehicleId: number) {
    e.preventDefault()
    e.stopPropagation()

    const vehicle = await this.getVehicle(vehicleId)
    if (!vehicle) {
      return
    }
    this.showVehicleEditDialog(e, vehicle)
  }

  newInsured (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showInsuredEditDialog(e)
  }

  newProperty (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showPropEditDialog(e)
  }
}
